<div class="overflow-y-auto">
    <p-tabs value="0" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab value="0">Overview</p-tab>
            <p-tab value="1">Activites</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <div class="m-0 overflow-y-auto min-w-[500px]">

                    <!-- Loading Spinner -->
                    <div *ngIf="isPipelineLoading" class="flex justify-center items-center py-10">
                        <p-progressSpinner styleClass="w-12 h-12"></p-progressSpinner>
                    </div>

                    <!-- Content after loading -->
                    <div *ngIf="!isPipelineLoading">
                    <div class="mt-2 mb-4 ">
                        <div *ngIf="editType == 'leads'">
                            <app-lead-status [currentStatus]="editLeadData.lead_status" [statuses]="leadStatusValues"></app-lead-status>
                        </div>

                        <div *ngIf="editType == 'registration'">
                            <app-registration-status
                                [currentStatus]="editLeadData.reg_data.status"></app-registration-status>
                        </div>

                        <div *ngIf="editType == 'application'">
                            <app-application-status
                                [currentStatus]="editLeadData.application_data.status"></app-application-status>
                        </div>

                        <div *ngIf="editType == 'enrollment'">
                            <app-enrollment-status
                                [currentStatus]="editLeadData.enrollment_data.enrollment_status"></app-enrollment-status>
                        </div>

                    </div>

                    <form #leadForm="ngForm" class="mt-5" (ngSubmit)="submitForm(leadForm.valid)">

                        <p-accordion value="-1">
                            <p-accordion-panel value="0">
                                <p-accordion-header>Bio Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Prefix</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                                                [options]="prefixOptions"></p-select>
                                        </div>



                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">First Name</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['first_name']" name="first_name"
                                                required pattern="^[a-zA-Z ]*$" #first_name="ngModel"
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter First
                                                Name</small>

                                            <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">
                                                Special characters are not allowed.
                                            </small>

                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Last Name</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['last_name']" name="last_name"
                                                required pattern="^[a-zA-Z ]*$" #last_name="ngModel"
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last
                                                Name</small>
                                            <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">
                                                Special characters are not allowed.
                                            </small>
                                        </div>

                                        <div *ngIf="isFixedColumn && editType !== 'leads' && editType !== 'enrollment'"
                                            class="col-span-1">
                                            <label class="block mb-2">Guardian Name</label>
                                            <input pInputText class="w-full shadow-none profile-input"
                                                [(ngModel)]="createFieldFormValue.reg_data.guardian_name"
                                                name="guardian_name" />
                                        </div>

                                        <div *ngIf="isFixedColumn && editType !== 'leads' && editType !== 'enrollment'"
                                            class="col-span-1">
                                            <label class="block mb-2">Guardian Contact</label>
                                            <input pInputText class="w-full shadow-none profile-input"
                                                [(ngModel)]="createFieldFormValue.reg_data.guardian_contact"
                                                name="guardian_contact" type="number" />
                                        </div>


                                        <div *ngIf="isFixedColumn && editType === 'enrollment'" class="col-span-1">
                                            <label class="block mb-2">Guardian Name</label>
                                            <input pInputText class="w-full shadow-none profile-input"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.guardian_name"
                                                name="guardian_name" />
                                        </div>

                                        <div *ngIf="isFixedColumn && editType === 'enrollment'" class="col-span-1">
                                            <label class="block mb-2">Guardian Contact</label>
                                            <input pInputText class="w-full shadow-none profile-input"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.guardian_contact"
                                                name="guardian_contact" type="number" />
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Date of Birth</label>
                                            <p-datepicker class="w-full  " appendTo="body" [inputStyle]="{
                                    'box-shadow':'none !important',
                                    'width': '100%',
                                    'border': 'none',
                                    'background-color': 'transparent',
                                    'border-radius': '10px',
                                }" [style]="{'box-shadow':'none !important',
                                    'width': '100%',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    'border-radius': '10px',
                                 }" [maxDate]="today" [(ngModel)]="createFieldFormValue['date_of_birth']"
                                                name="date_of_birth" />
                                            <div class="w-full profile-input h-[33px] -mt-[32px] z-50 rounded-[5px]">
                                            </div>
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Age</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['age']" name="age" />
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Gender</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['gender']" name="gender"
                                                [options]="genderOptions" />
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Nationality</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                                        </div>


                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Interested Course</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['interested_course']"
                                                name="interested_course" />
                                        </div>


                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="3">
                                <p-accordion-header>
                                    Assign To , Query, Education and Course Details
                                </p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div class="col-span-1"
                                            *ngIf="editType !== 'application' && editType !== 'enrollment'">
                                            <label class="block mb-2 ">Assigned To</label>
                                            <p-select appendTo="body" class="w-full profile-select"
                                                [(ngModel)]="createFieldFormValue['assigned_to']" name="assigned_to"
                                                [options]="users"></p-select>
                                        </div>

                                        <div class="col-span-1" *ngIf="editType === 'application'">
                                            <label class="block mb-2 ">Assigned To</label>
                                            <p-select appendTo="body" class="w-full profile-select"
                                                [(ngModel)]="createFieldFormValue.application_data['assign_to']"
                                                name="assigned_to" [options]="users"></p-select>
                                        </div>


                                        <div class="col-span-1" *ngIf="editType === 'enrollment'">
                                            <label class="block mb-2 ">Assigned To</label>
                                            <p-select appendTo="body" class="w-full profile-select"
                                                [(ngModel)]="createFieldFormValue.enrollment_data['assign_to']"
                                                name="assigned_to" [options]="users"></p-select>
                                        </div>

                                        <div *ngIf="isFixedColumn && editType === 'leads'" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Query Type</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['query_type']" name="query_type"
                                                [options]="queryTypes" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['query_type']}" />
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['query_type']">Select Query
                                                Type</small>
                                        </div>

                                        <div *ngIf="isFixedColumn && editType != 'leads' && editType != 'enrollment'"
                                            class="col-span-1">
                                            <label class="block mb-2">Previous Education</label>
                                            <input pInputText class="w-full shadow-none profile-input"
                                                [(ngModel)]="createFieldFormValue.reg_data.previous_education"
                                                name="previous_education" type="text" />
                                        </div>

                                        <div *ngIf="isFixedColumn && editType == 'registration'" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Preferred Course</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.reg_data.preferred_course"
                                                name="preferred_course" [options]="allCourses" optionLabel="name"
                                                optionValue="course_id" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.reg_data?.preferred_course}">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.reg_data?.preferred_course">
                                                Select Preferred Course
                                            </small>
                                        </div>

                                        <div *ngIf="isFixedColumn && editType == 'application'" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Selected Course</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.application_data.course_id"
                                                name="preferred_course" [options]="allCourses" optionLabel="name"
                                                optionValue="course_id" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.application_data?.course_id}">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.application_data?.course_id">
                                                Select Preferred Course
                                            </small>
                                        </div>

                                        <div *ngIf="isFixedColumn && editType == 'enrollment'" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Selected Course</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.course_id"
                                                name="preferred_course" [options]="allCourses" optionLabel="name"
                                                optionValue="course_id" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.course_id}">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.course_id">
                                                Select Preferred Course
                                            </small>
                                        </div>


                                    </div>

                                </p-accordion-content>
                            </p-accordion-panel>


                            <p-accordion-panel value="10" *ngIf="editType == 'leads'">
                                <p-accordion-header>Lead Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div class="col-span-1">
                                            <div class="flex items-center justify-between mb-2">
                                                <label class="block requiredValue">Lead Pipeline</label>
                                                <button type="button" (click)="managePipeline()" 
                                                    class="text-blue-600 hover:text-blue-800 underline text-sm font-semibold">
                                                    ⚙ Manage Pipeline
                                                </button>
                                            </div>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['pipeline_id']" name="pipeline_id"
                                                [options]="pipelineStages" optionLabel="label" optionValue="value"
                                                (onChange)="onPipelineChange($event)"
                                                required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['pipeline_id']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['pipeline_id']">Select Lead
                                                Pipeline</small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Lead Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['lead_status']" name="lead_status"
                                                [options]="leadStatusList" optionLabel="stage_name" optionValue="stage_name"
                                                (onChange)="onStatusChange($event)"
                                                required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['lead_status']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['lead_status']">Select Lead
                                                Status</small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2">Lead Score</label>
                                            <input pInputText class="w-full profile-input"
                                                [(ngModel)]="createFieldFormValue['lead_score']" name="lead_score"
                                                [disabled]="true" placeholder="Score will be auto-filled"
                                                style="opacity: 0.6; cursor: not-allowed;" />
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Lead Type</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue['lead_type']" name="lead_type"
                                                [options]="leadTypes" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['lead_type']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['lead_type']">Select Lead
                                                Type</small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Source</label>
                                            <p-select class="w-full profile-select " appendTo="body"
                                                [(ngModel)]="createFieldFormValue['source']" name="source"
                                                [options]="leadSources" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['source']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['source']">Select Lead
                                                Source</small>

                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>


                            <p-accordion-panel value="11" *ngIf="editType == 'registration'">
                                <p-accordion-header>Registration Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue"> Registration Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.reg_data.status" name="lead_status"
                                                [options]="registrationStatusList" required [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.reg_data?.status
                                    }">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.reg_data?.status">
                                                Select Status
                                            </small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Source</label>
                                            <p-select class="w-full profile-select " appendTo="body"
                                                [(ngModel)]="createFieldFormValue['source']" name="source"
                                                [options]="leadSources" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['source']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['source']">Select
                                                Source</small>

                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="11" *ngIf="editType == 'application'">
                                <p-accordion-header>Application Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Application Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.application_data.status"
                                                name="lead_status" [options]="applicationStatusList" required [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.application_data?.status
                                    }">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.application_data?.status">
                                                Select Status
                                            </small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Source</label>
                                            <p-select class="w-full profile-select " appendTo="body"
                                                [(ngModel)]="createFieldFormValue['source']" name="source"
                                                [options]="leadSources" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['source']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['source']">Select
                                                Source</small>

                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="12" *ngIf="editType == 'enrollment'">
                                <p-accordion-header>Enrollment Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Enrollment Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.enrollment_status"
                                                name="lead_status" [options]="enrollmentStatusList" required [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.enrollment_status
                                    }">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.enrollment_status">
                                                Select Status
                                            </small>
                                        </div>

                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Source</label>
                                            <p-select class="w-full profile-select " appendTo="body"
                                                [(ngModel)]="createFieldFormValue['source']" name="source"
                                                [options]="leadSources" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['source']}"></p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['source']">Select
                                                Source</small>

                                        </div>

                                        <div class="col-span-1" *ngIf="editType === 'enrollment'">
                                            <label class="block mb-2 ">Mode of Study</label>
                                            <p-select appendTo="body" class="w-full profile-select"
                                                [(ngModel)]="createFieldFormValue.enrollment_data['mode_of_study']"
                                                name="mode_of_study" [options]="modeOfStudyOptions"></p-select>
                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="1">
                                <p-accordion-header>Contact Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Contact Email</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['email']" name="email" required
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue['email']">Enter
                                                Contact
                                                Email</small>
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Contact Number</label>
                                            <!-- <input pInputText class="w-1/4" type="number" style="box-shadow: none !important;"
                                        placeholder="code" [(ngModel)]="createFieldFormValue['country_code']" name="country_code"
                                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['country_code'] }"
                                        required /> -->
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['phone'] }"
                                                [(ngModel)]="createFieldFormValue['phone']" name="phone" required />
                                            <small class="text-red-500" *ngIf="isSubmitted && (!createFieldFormValue['phone']
                                )">Enter Contact Number</small>
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Alternate Number</label>
                                            <!-- <input pInputText class="w-1/4" type="number" style="box-shadow: none !important;"
                                        placeholder="code" [(ngModel)]="createFieldFormValue['alternate_code']"
                                        name="alternate_code" /> -->
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['alternate_phone']"
                                                name="alternate_phone" />
                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="2">
                                <p-accordion-header>Demographic Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Preferred Location</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['preferred_location']"
                                                name="preferred_location" />
                                        </div>

                                        <!-- city state -->
                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">City</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['city']" name="city" />
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">State</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['state']" name="state" />
                                        </div>


                                        <!-- country postal_code -->

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Country</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['country']" name="country" />
                                        </div>

                                        <div *ngIf="isFixedColumn" class="col-span-1">
                                            <label class="block mb-2">Postal Code</label>
                                            <input pInputText class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                                        </div>



                                    </div>
                                    <div class="grid grid-cols-1 mt-4">
                                        <div class="col-span-1">
                                            <label class="block mb-2">Address</label>
                                            <textarea pTextarea class="w-full profile-input" rows="5"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue['address']" name="address"></textarea>
                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>



                            <p-accordion-panel value="4" *ngIf="editType != 'leads'">
                                <p-accordion-header>
                                    Document Details
                                </p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div *ngIf="isFixedColumn && editType != 'leads' && editType != 'enrollment'"
                                            class="col-span-1">
                                            <label class="block mb-2 requiredValue">Document Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.reg_data.document_status"
                                                name="document_status" [options]="documentStatusList" required
                                                [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.reg_data?.document_status
                                    }">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.reg_data?.document_status">
                                                Select Document Status
                                            </small>
                                        </div>
                                    </div>

                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div *ngIf="isFixedColumn && editType === 'enrollment'" class="col-span-1">
                                            <label class="block mb-2 requiredValue">Document Status</label>
                                            <p-select class="w-full shadow-none profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.document_status"
                                                name="document_status" [options]="documentStatusList" required
                                                [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.document_status
                                    }">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.document_status">
                                                Select Document Status
                                            </small>
                                        </div>
                                    </div>

                                </p-accordion-content>
                            </p-accordion-panel>



                            <p-accordion-panel value="13" *ngIf="editType == 'enrollment'">
                                <p-accordion-header>Payment Details</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <!-- Payment For -->
                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Payment For</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [placeholder]="'Select Payment For'"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_details.payment_for"
                                                name="payment_for" [options]="paymentForList" optionLabel="label"
                                                (ngModelChange)="onPaymentForChange($event)" optionValue="value"
                                                required
                                                [ngClass]="{'ng-invalid ng-dirty':  isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.payment_for}">
                                            </p-select>

                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.payment_for">
                                                Select Payment For
                                            </small>
                                        </div>

                                        <!-- Amount -->
                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Amount</label>
                                            <input type="number" class="w-full p-inputtext profile-input"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_details.amount"
                                                name="amountfv" required
                                                [ngClass]="{'ng-invalid ng-dirty': isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.amount}" />
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.amount">
                                                Enter Amount
                                            </small>
                                        </div>

                                        <!-- Payment Status -->
                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Payment Status</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_status"
                                                name="payment_status" [options]="paymentStatusList" required
                                                [ngClass]="{'ng-invalid ng-dirty': isSubmitted && !createFieldFormValue.enrollment_data?.payment_status}">
                                            </p-select>
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.payment_status">
                                                Select Status
                                            </small>
                                        </div>

                                        <!-- Payment Mode -->
                                        <div class="col-span-1">
                                            <label class="block mb-2 requiredValue">Payment Mode</label>
                                            <p-select class="w-full profile-select" appendTo="body"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_details.payment_mode"
                                                name="payment_mode" [options]="paymentModeList" required
                                                [ngClass]="{'ng-invalid ng-dirty': isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.payment_mode}">
                                            </p-select>
                                            <small class="text-red-500"
                                                *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.payment_details?.payment_mode">
                                                Select Payment Mode
                                            </small>
                                        </div>

                                        <!-- Payment Date -->
                                        <div class="col-span-1">
                                            <label class="block mb-2">Payment Date</label>
                                            <p-datepicker class="w-full  " appendTo="body" [inputStyle]="{
                                    'box-shadow':'none !important',
                                    'width': '100%',
                                    'border': 'none',
                                    'background-color': 'transparent',
                                    'border-radius': '10px',
                                }" [style]="{'box-shadow':'none !important',
                                    'width': '100%',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    'border-radius': '10px',
                                 }" [maxDate]="today"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_details.payment_date"
                                                dateFormat="dd-mm-yy" name="payment_date" />
                                            <div class="w-full profile-input h-[33px] -mt-[32px] z-50 rounded-[5px]">
                                            </div>
                                        </div>

                                        <!-- payment remarks -->
                                        <div class="col-span-1">
                                            <label class="block mb-2">Payment Remarks</label>
                                            <textarea pTextarea class="w-full profile-input"
                                                style="box-shadow: none !important;"
                                                [(ngModel)]="createFieldFormValue.enrollment_data.payment_details.remarks"
                                                name="payment_remarks"></textarea>
                                        </div>

                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>


                            <p-accordion-panel value="5">
                                <p-accordion-header>
                                    Remarks
                                </p-accordion-header>
                                <p-accordion-content>
                                    <div class="col-span-1">
                                        <label class="block mb-2">Remarks</label>
                                        <textarea pTextarea class="w-full profile-input" rows="5"
                                            style="box-shadow: none !important;"
                                            [(ngModel)]="createFieldFormValue['remarks']" name="remarks"></textarea>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>


                            <p-accordion-panel value="6">
                                <p-accordion-header>
                                    Other Details
                                </p-accordion-header>
                                <p-accordion-content>
                                    <div *ngIf="fieldValues" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                        <div *ngFor="let item of allLeadFeilds">
                                            <div class="col-span-1 w-full">
                                                <label class="block mb-2"
                                                    [ngClass]="{ 'requiredValue': item.required === 'true' }">
                                                    {{ item.label }}
                                                </label>

                                                <!-- Regular Input -->
                                                <input *ngIf="item.type !== 'select' && item.type !== 'textarea'"
                                                    pInputText class="w-full profile-input"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [required]="item.required === 'true' ? true : false"
                                                    [ngModelOptions]="{ standalone: false }" [ngClass]="{
                                    'ng-invalid ng-dirty': isSubmitted && item.required === 'true' && !fieldValues[item.field_name]
                                  }" />

                                                <!-- Textarea -->
                                                <textarea *ngIf="item.type === 'textarea'" pTextarea
                                                    style="box-shadow: none !important;" class="w-full"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [required]="item.required === 'true' ? true : false"
                                                    [placeholder]="item.placeholder"></textarea>

                                                <!-- Select -->
                                                <p-select *ngIf="item.type === 'select'" class="w-full profile-select"
                                                    appendTo="body" [required]="item.required === 'true' ? true : false"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [options]="item.data" [placeholder]="item.placeholder"></p-select>

                                                <!-- Validation Message -->
                                                <small class="text-red-500"
                                                    *ngIf="isSubmitted && item.required === 'true' && !fieldValues[item.field_name]">
                                                    Enter {{ item.label }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>





                        </p-accordion>


                        <div class="mt-4 w-full">
                            <p-button type="submit" [label]="'Update'" class="w-full" [style]="{width: '100%'}"
                                [icon]="'pi pi-pencil'" [disabled]="isLoading" [loading]="isLoading"
                                class="p-button-primary w-full md:w-auto"></p-button>
                        </div>

                    </form>
                    </div>
                </div>
            </p-tabpanel>
            <p-tabpanel value="1" class="p-0 min-w-[500px]">
                <app-lead-activity-tabs
                [editType]="editType"></app-lead-activity-tabs>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>